import { Notification, User } from 'z3k-config';
import { List } from 'immutable';
import { useContext } from 'react';
import { Z3KSettings, Z3KSettingsEditor } from 'z3k-settings/provider/types';
import { usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { selectDevice } from 'entities/device/lib';
export function useNotificationsState() {
    const { config } = useContext(Z3KSettingsEditor);
    const { get_device_settings, device_id } = useContext(Z3KSettings);
    const user = User.get.all(config)[0];
    const device_settings = get_device_settings();
    const redux_device = usePartialAppSelector(selectDevice, device_id);
    const gsm = {
        sms_enabled: Notification.get.all(config).some(Notification.isSmsEnabled),
        voice_enabled: Notification.get.all(config).some(Notification.isVoiceEnabled),
        info_events: User.get.all(config).some(User.isInfoNotificationsEnabled),
        alarm_events: User.get.all(config).some(User.isAlarmNotificationsEnabled),
        phones: user != null
            ? List(user.phone.split(',').map((s) => s.trim())).withMutations((list) => {
                while (list.size < 3)
                    list.push('');
            })
            : List.of('', '', ''),
    };
    const email = {
        server_notifications_events: device_settings?.server_notifications?.events?.enabled ??
            redux_device?.server_notifications?.events?.enabled ??
            false,
        server_notifications_offline: device_settings?.server_notifications?.offline?.enabled ??
            redux_device?.server_notifications?.offline?.enabled ??
            false,
        server_notifications_offline_timeout: (device_settings?.server_notifications?.offline?.timeout ??
            redux_device?.server_notifications?.offline?.timeout ??
            1200) / 60,
    };
    return { gsm, email };
}
